import { useEffect, useState } from 'react';

import { APOLLO_CLIENTS } from '@/graphql/client';
import type { OrderAppBillingCountry } from '@/graphql/orderApp/api';
import { useBillingCountriesQuery } from '@/graphql/orderApp/api';

export const useBillingCountry = () => {
  const { data, error, loading } = useBillingCountriesQuery({
    context: {
      client: APOLLO_CLIENTS.orderApp,
    },
  });

  const [billingCountries, setBillingCountries] = useState<
    OrderAppBillingCountry[]
  >([]);

  useEffect(() => {
    if (!loading && data) {
      setBillingCountries(data.billingCountries ?? []);
    }
  }, [loading, data]);

  const isBillingCountryExistence = (
    countryCode?: string,
    countries?: OrderAppBillingCountry[],
  ): boolean => {
    if (!countryCode || !countries?.length) return false;

    const isCountryExist = countries.some(
      (billingCountry) => billingCountry.code === countryCode,
    );

    return isCountryExist || false;
  };

  return {
    loading,
    error,
    billingCountries,
    isBillingCountryExistence,
  };
};
